import { useState } from "react";
import {
  Flex,
  Button,
  Image,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Input,
  Box,
  useColorModeValue,
  IconButton,
} from "@chakra-ui/react";
import Select from "react-select";
import filterIcon from "../../../../assets/img/nfts/filter.svg";

const DynamicFilterall = ({ filters = [] }) => {
  // Main state for selected values
  const [selectedValues, setSelectedValues] = useState(
    filters.reduce(
      (acc, filter) => ({
        ...acc,
        [filter.name]: filter.isMulti ? [] : filter.defaultText,
      }),
      {}
    )
  );

  // Temporary state before saving changes
  const [tempSelectedValues, setTempSelectedValues] = useState({});
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [activeDateFilter, setActiveDateFilter] = useState(null);

  // Disclosure hooks for modals
  const { isOpen: isModalOpen, onOpen: openModal, onClose: closeModal } = useDisclosure();
  const { isOpen: isDateModalOpen, onOpen: openDateModal, onClose: closeDateModal } = useDisclosure();

  // Handle generic select change
  const handleSelect = (filterName, value) => {
    setTempSelectedValues((prev) => ({ ...prev, [filterName]: value }));
  };

  // Handle date range selection
  const handleSelectDateRange = (filterName) => {
    setActiveDateFilter(filterName);
    openDateModal();
  };

  // Save selected values to main state
  const handleSaveData = () => {
    setSelectedValues(tempSelectedValues);
    filters.forEach((filter) => {
      if (filter.onSelect && tempSelectedValues[filter.name] !== undefined) {
        filter.onSelect(tempSelectedValues[filter.name]);
      }
    });
    closeModal();
  };

  // Cancel operation (reset temporary state)
  const handleCancelData = () => {
    setTempSelectedValues(selectedValues);
    closeModal();
  };

  // Save selected date range
  const handleSaveDateRange = () => {
    if (startDate && endDate && activeDateFilter) {
      const formattedDateRange = `${startDate} - ${endDate}`;

      setTempSelectedValues((prev) => ({
        ...prev,
        [activeDateFilter]: formattedDateRange,
      }));

      closeDateModal();
    }
  };

  const textColor = useColorModeValue("secondaryGray.900", "white");

  return (
    <Flex alignItems="center" gap={2}>
      <IconButton
      icon={ <Image src={filterIcon} alt="Filter Icon" width={4} onClick={openModal} style={{ cursor: "pointer" }} />}
      aria-label="Filter Icon"
      // size="sm"
      />
     

      {/* Main Filter Modal */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Filters</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          {filters.map((filter) => (
            <Box key={filter.name} my={2}>
              <label>{filter?.label}</label>
              {filter.type === "calendar" ? (
                <>
                  <Input
                    type="date"
                    value={tempSelectedValues[filter.name] || new Date().toISOString().split("T")[0]}  // Set default to today's date
                    onChange={(e) =>
                      setTempSelectedValues((prev) => ({ ...prev, [filter.name]: e.target.value }))
                    }
                  />
                </>
              ) : (
                <Select
                  isMulti={filter.isMulti}
                  isClearable
                  placeholder={filter.defaultText}
                  value={
                    filter.isMulti
                      ? tempSelectedValues[filter.name]?.map((val) => ({ label: val, value: val })) || []
                      : tempSelectedValues[filter.name]
                      ? { label: tempSelectedValues[filter.name], value: tempSelectedValues[filter.name] }
                      : null
                  }
                  options={[
                    ...filter.options.map((option) => ({ label: option, value: option })),
                    ...(filter.type === "date"
                      ? [{ label: "Select Date Range", value: "select_date_range" }]
                      : []),
                  ]}
                  onChange={(selectedOption) => {
                    if (selectedOption === null) {
                      setTempSelectedValues((prev) => ({ ...prev, [filter.name]: filter.isMulti ? [] : "" }));
                    } else if (selectedOption.value === "select_date_range") {
                      handleSelectDateRange(filter.name);
                    } else {
                      const selectedValues = filter.isMulti
                        ? selectedOption.map((option) => option.value)
                        : selectedOption.value;

                      setTempSelectedValues((prev) => ({ ...prev, [filter.name]: selectedValues }));
                    }
                  }}
                />
              )}
            </Box>
          ))}
          </ModalBody>
          <ModalFooter>
            <Button width="50%" colorScheme="blue" mr={3} onClick={handleSaveData}>
              Save
            </Button>
            <Button width="50%" border="1px solid" borderColor="blue" onClick={handleCancelData}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Date Range Modal */}
      <Modal isOpen={isDateModalOpen} onClose={closeDateModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Date Range</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <label>Start Date:</label>
              <Input
                type="date"
                value={startDate}
                color={textColor}
                max={endDate}
                onChange={(e) => setStartDate(e.target.value)}
                mb={4}
              />
              <label>End Date:</label>
              <Input
                type="date"
                value={endDate}
                color={textColor}
                min={startDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSaveDateRange}>
              Save
            </Button>
            <Button variant="ghost" onClick={closeDateModal}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default DynamicFilterall;
